const avatarInitials = ({ size, name, email }) => {
  const length = size < 32 && !Number.isInteger(name) ? 1 : 2;
  return name
    ? getInitials(name).substring(0, length).toUpperCase()
    : String(email).substring(0, length).toUpperCase();
};

const getInitials = (string) => {
  let names = string.toString().split(' ');

  if (names.length > 1) {
    return names.map((s) => s[0]).join('');
  } else {
    return string.toString();
  }
};

export default avatarInitials;
